import Modal from '@Components/Shared/Modals/Modal';

const EnableQuickBidModal = (props) => {
    return (
        <Modal containerClassName='enable-quick-bid-modal'>
            <Modal.Header onClose={props.onClose}>
                <Modal.Title>
                    {translator.translate('sandhills.quickbid')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    <span dangerouslySetInnerHTML={{ __html: translator.translate('sandhills.tradepubwebsite.mvc.enablequickbid') }}></span> <br/>
                    {translator.translate('sandhills.tradepubwebsite.mvc.yourbidsimmediate2')} - {translator.translate('sandhills.tradepubwebsite.mvc.youwillreceivenoprompt').replace(/\{0\}/g, '"')}..
                </p>
                <br />
                <br />
                <strong>{translator.translate('sandhills.tradepubwebsite.mvc.doyouwanttocontinue')}</strong>
                <input type='button' className='enable-quick-bid-modal-btn button ts-button' value={translator.translate('sandhills.tradepubwebsite.mvc.yesturnonquickbid')} onClick={props.onConfirm} />
                <input type='button' className='cancel-quick-bid-modal-btn button ts-button' value={translator.translate('sandhills.cancel')} onClick={props.onClose} />
            </Modal.Body>
        </Modal>
    );
}

export default EnableQuickBidModal;